/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon24Solid = forwardRef('BuildingGovIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m1.55 8.515 7.797-6.353a4.2 4.2 0 0 1 5.306 0l7.797 6.353c1.02.832.433 2.485-.884 2.485H19.95v7h.55a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 20.5v-1A1.5 1.5 0 0 1 3.5 18h.55v-7H2.435C1.117 11 .529 9.347 1.55 8.515Zm5 2.485v7H8.6v-7H6.55Zm4.55 0v7h1.8v-7h-1.8Zm4.3 0v7h2.05v-7H15.4Z" })));
});
